const { bodyLock } = await import(`./body-lock.js?v=${Date.now()}`);
const handleNewsletterForms = (alreadyHasNewsletter) => {
  const handleModalNewsletter = () => {
    const newsletterModal = document.querySelector("newsletter-modal");
    const trigger = document.querySelector(".newsletter-trigger");
    if (!trigger || !newsletterModal) return;
    if (!alreadyHasNewsletter) {
      const handleTriggerClick = () => {
        newsletterModal.classList.toggle("is-open");
      };
      trigger.addEventListener("click", handleTriggerClick);
      trigger.innerHTML = `
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M8 10V22H24V10M8 10H24M8 10L16.2051 17.0345L24 10"
            stroke="#0C0C0C"
            stroke-width="1.5"></path>
          <rect
            x="17"
            width="15"
            height="15"
            rx="7.5"
            fill="#B14B1E"></rect>
          <path d="M23.936 11.5V4.405H22.363V3.305H25.223V11.5H23.936Z" fill="white"></path>
        </svg>
      `;
      const form = newsletterModal.querySelector("form");
      if (!form) return;
      const observer = new MutationObserver((mutations) => {
        const formText = form.textContent.toLowerCase();
        if (formText.includes("bedankt voor je inschrijving") || formText.includes("thank you for signing up") || formText.includes("merci de vous être inscrit") || formText.includes("bedankt voor het aanmelden")) {
          localStorage.setItem("hasNewsletter", true);
          trigger.removeEventListener("click", handleTriggerClick);
          trigger.innerHTML = `
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M8 10V22H24V10M8 10H24M8 10L16.2051 17.0345L24 10"
                stroke="#0C0C0C"
                stroke-width="1.5"></path>
            </svg>
          `;
          setTimeout(() => {
            newsletterModal.classList.remove("is-open");
          }, 2e3);
          observer.disconnect();
        }
      });
      observer.observe(form, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }
  };
  const handleSectionNewsletter = () => {
    const newsletterForms = document.querySelectorAll(".newsletter form");
    newsletterForms.forEach((form) => {
      const observer = new MutationObserver((mutations) => {
        const formText = form.textContent.toLowerCase();
        if (formText.includes("bedankt voor je inschrijving") || formText.includes("thank you for signing up") || formText.includes("merci de vous être inscrit") || formText.includes("bedankt voor het aanmelden")) {
          localStorage.setItem("hasNewsletter", true);
          observer.disconnect();
        }
      });
      observer.observe(form, {
        childList: true,
        subtree: true,
        characterData: true
      });
    });
  };
  handleModalNewsletter();
  handleSectionNewsletter();
};
class HeaderComponent extends HTMLElement {
  constructor() {
    super();
    const init = () => {
      handleAnnouncementBarScroll();
      handleAnnouncementBarEventListeners();
      handleMobileToggle();
      handleNavigationButtonClick();
      handleMegaMenu();
      handleWishlistCounter();
      handleNewsletterModal();
    };
    const handleWishlistCounter = () => {
      var _a;
      let counter = document.querySelector(".js-counter");
      let amount = (_a = JSON.parse(
        localStorage.getItem("Suite702_wishlist")
      )) == null ? void 0 : _a.length;
      if (amount > 0) {
        counter.classList.add("js-counter--active");
        counter.innerHTML = amount;
      } else {
        counter.classList.remove("js-counter--active");
        counter.innerHTML = "";
      }
    };
    const hideAnnouncementBar = (headerElement) => {
      let announcementBarElement = document.querySelector(".announcement-bar");
      let mobileNavigation = document.querySelector(".mobile-navigation");
      let buttonRow = document.querySelector(".button-row");
      let configuratorMedia = document.querySelector(".configurator-media");
      let predictiveSearch = document.querySelector(
        ".predictive-search-modal"
      );
      let megaMenus = document.querySelectorAll(".mega-menu");
      if (headerElement && announcementBarElement) {
        announcementBarElement.style.zIndex = "1000";
        announcementBarElement.classList.add("header--has-scrolled");
        headerElement.classList.add("header--has-scrolled");
        headerElement.style.transform = `translateY(0px)`;
        predictiveSearch.style.transform = `translateY(0px)`;
        mobileNavigation.style.transform = `translateY(0px)`;
        megaMenus.forEach((megaMenu) => {
          megaMenu.style.top = `62px`;
        });
      }
      if (buttonRow && configuratorMedia) {
        buttonRow.style.top = "368px";
        configuratorMedia.style.top = "78px";
      }
    };
    const setHideAnnouncementBarSession = (state) => {
      sessionStorage.setItem("showAnnouncementBar", state);
    };
    const getStateOfAnnouncementBarSession = () => {
      return sessionStorage.getItem("showAnnouncementBar");
    };
    const showAnnouncementBar = (headerElement) => {
      let announcementBarElement = document.querySelector(".announcement-bar");
      let announcementBarHeight = announcementBarElement.offsetHeight;
      let mobileNavigation = document.querySelector(".mobile-navigation");
      let sessionState = getStateOfAnnouncementBarSession();
      let buttonRow = document.querySelector(".button-row");
      let configuratorMedia = document.querySelector(".configurator-media");
      let predictiveSearch = document.querySelector(
        ".predictive-search-modal"
      );
      let megaMenus = document.querySelectorAll(".mega-menu");
      if (headerElement && announcementBarElement) {
        if (sessionState === "false") {
          announcementBarElement.classList.add("js-disabled");
        } else {
          headerElement.style.transform = `translateY(${announcementBarHeight}px)`;
          predictiveSearch.style.transform = `translateY(${announcementBarHeight}px)`;
          mobileNavigation.style.transform = `translateY(${announcementBarHeight}px)`;
          setTimeout(() => {
            if (!headerElement.classList.contains("header--has-scrolled") && !announcementBarElement.classList.contains("js-disabled")) {
              announcementBarElement.style.zIndex = "1005";
            }
          }, 250);
          megaMenus.forEach((megaMenu) => {
            megaMenu.style.top = `${62 + announcementBarHeight}px`;
          });
        }
        announcementBarElement.classList.remove("header--has-scrolled");
        headerElement.classList.remove("header--has-scrolled");
      }
      if (buttonRow && configuratorMedia) {
        buttonRow.style.top = "400px";
        configuratorMedia.style.top = "110px";
      }
    };
    const handleAnnouncementBarScroll = () => {
      let headerElement = document.querySelector(".header");
      let sessionState = getStateOfAnnouncementBarSession();
      let announcementBarElement = document.querySelector(".announcement-bar");
      if (sessionState === "false") {
        announcementBarElement.classList.add("js-disabled");
      } else {
        showAnnouncementBar(headerElement);
      }
      if (headerElement) {
        let announcementBarHeight = announcementBarElement.offsetHeight;
        let offset = announcementBarHeight * 3;
        window.addEventListener("scroll", function() {
          let scrollPosition = window.scrollY;
          if (scrollPosition > offset) {
            hideAnnouncementBar(headerElement);
          } else {
            showAnnouncementBar(headerElement);
          }
        });
      }
    };
    const handleAnnouncementBarEventListeners = () => {
      let headerElement = document.querySelector(".header");
      let announcementBarCloseButtonElement = document.querySelector(
        "#js-close-announcement-bar"
      );
      if (announcementBarCloseButtonElement && headerElement) {
        announcementBarCloseButtonElement.addEventListener("click", () => {
          setHideAnnouncementBarSession(false);
          hideAnnouncementBar(headerElement);
        });
      }
    };
    const handleMobileToggle = () => {
      let toggle = document.querySelector("#js-trigger-mobile-menu");
      let mobileNav = document.querySelector(".mobile-navigation");
      let headerElement = document.querySelector(".header");
      let searchResultsHolder = document.querySelector(
        ".search-results-holder"
      );
      let searchModal = document.querySelector("search-modal");
      searchModal == null ? void 0 : searchModal.querySelector(".form");
      searchModal == null ? void 0 : searchModal.querySelector(".form__submit");
      if (!toggle) return false;
      toggle.addEventListener("click", (event) => {
        event.preventDefault();
        toggle.classList.toggle("is-open");
        if (headerElement.dataset.template == "index") ;
        mobileNav.classList.toggle("js-mobile-navigation-open");
        if (searchResultsHolder) {
          searchResultsHolder.remove();
        }
        let suggestionsHolder = document.querySelector(".suggestions-holder");
        let suggestionBackground = document.querySelector(
          ".js-suggestion-background"
        );
        let backgroundCurtain = document.querySelector(".background-curtain");
        let popularResults = document.querySelector(".popular-results");
        let predictiveSearch = document.querySelector(
          ".predictive-search-results--active"
        );
        suggestionsHolder == null ? void 0 : suggestionsHolder.classList.remove("suggestions-holder--active");
        suggestionBackground == null ? void 0 : suggestionBackground.classList.remove("background-curtain--active");
        backgroundCurtain == null ? void 0 : backgroundCurtain.classList.remove("background-curtain--active");
        popularResults == null ? void 0 : popularResults.classList.remove("js-active");
        if (predictiveSearch) {
          predictiveSearch.classList.add("search-hidden");
        }
        if (mobileNav.classList.contains("js-mobile-navigation-open")) {
          bodyLock.lock();
          document.querySelector("#chat-button").style.display = "none";
        } else {
          bodyLock.unlock();
          document.querySelector("#chat-button").style.display = "block";
        }
      });
    };
    let handleNewsletterModal = async () => {
      document.addEventListener("DOMContentLoaded", () => {
        let newsletterModal = document.querySelector("newsletter-modal");
        let trigger = document.querySelector(".newsletter-trigger");
        let closeTrigger = document.querySelector(".newsletter-close-trigger");
        let alreadyHasNewsletter = localStorage.getItem("hasNewsletter");
        if (!trigger || !newsletterModal) return;
        handleNewsletterForms(alreadyHasNewsletter);
        if (alreadyHasNewsletter) return;
        closeTrigger == null ? void 0 : closeTrigger.addEventListener("click", () => {
          newsletterModal.classList.remove("is-open");
        });
        newsletterModal.addEventListener("click", (e) => {
          let modalInner = newsletterModal.querySelector(
            ".newsletter-modal__inner"
          );
          if (!modalInner.contains(e.target)) {
            newsletterModal.classList.remove("is-open");
          }
        });
      });
    };
    const closeMegaMenu = (megaMenuElement) => {
      if (megaMenuElement) {
        megaMenuElement.classList.remove("js-mega-menu-open");
        megaMenuElement.style.transform = "translateX(100%)";
      }
    };
    const openMegaMenu = (megaMenuElement) => {
      if (megaMenuElement) {
        megaMenuElement.classList.add("js-mega-menu-open");
        megaMenuElement.style.transform = "translateX(0)";
      }
    };
    const handleOpenMobileMegaMenu = (megaMenuId) => {
      let megaMenuElement = document.getElementById(megaMenuId);
      if (megaMenuElement.classList.contains("js-mega-menu-open")) {
        closeMegaMenu(megaMenuElement);
      } else {
        openMegaMenu(megaMenuElement);
      }
    };
    const handleNavigationButtonClick = () => {
      let allNavigationMenuItem = document.querySelectorAll(
        ".js-trigger-mega-menu"
      );
      allNavigationMenuItem.forEach((navigationMenuItem) => {
        let megaMenuId = navigationMenuItem.dataset.menuId;
        navigationMenuItem.addEventListener("click", () => {
          handleOpenMobileMegaMenu(megaMenuId);
        });
      });
    };
    const handleActiveItems = () => {
      let layer1items = document.querySelectorAll(".js-layer1");
      if (layer1items) {
        layer1items.forEach((item) => {
          item.classList.remove("active");
        });
      }
    };
    const handleMegaMenu = () => {
      let megaMenuButtons = document.querySelectorAll(
        ".header__menu .nav__item.nav__item--mega-menu"
      );
      let megaMenuContainer = document.querySelector(".mega-menu-container");
      let headerElement = document.querySelector(".header");
      if (megaMenuButtons.length === 0) return false;
      let breakpointTablet = "1024px";
      if (!matchMedia(`screen and (min-width: ${breakpointTablet})`).matches)
        return false;
      function addListenerMulti(el, s, fn) {
        s.split(" ").forEach((e) => el.addEventListener(e, fn, false));
      }
      const closeAllMegaMenu = () => {
        let megaMenuItems = megaMenuContainer.querySelectorAll(".mega-menu");
        let body = document.querySelector("body");
        if (body.classList.contains("template-index")) ;
        megaMenuButtons.forEach(
          (button) => button.querySelector(".nav__button").classList.remove("nav__button--active")
        );
        if (megaMenuItems.length > 0)
          megaMenuItems.forEach((item) => {
            if (item.id !== "shop") {
              item.classList.remove("js-active");
            }
          });
        handleActiveItems();
      };
      const openMegaMenu2 = (target) => {
        let megaMenu = document.querySelector(".mega-menu" + target);
        closeAllMegaMenu();
        megaMenuContainer.classList.add("js-active");
        headerElement.classList.add("js-active");
        megaMenu.classList.add("js-active");
      };
      megaMenuContainer.addEventListener(
        "mouseleave",
        () => closeAllMegaMenu()
      );
      megaMenuButtons.forEach((button) => {
        addListenerMulti(button, "click mouseenter", (event) => {
          let target = button.querySelector(".nav__button").dataset.target ? button.querySelector(".nav__button").dataset.target : null;
          if (target) openMegaMenu2(target);
          let buttonElement = button.querySelector(".nav__button");
          if (buttonElement) buttonElement.classList.add("nav__button--active");
        });
      });
    };
    init();
  }
}
customElements.define("header-component", HeaderComponent);
